import { withAsync } from 'view/common/with-async';
import { lazyForPaint } from 'react-loosely-lazy';
import React from 'react';
export const AsyncAdvertiseRequestServiceDeskFooter = withAsync({
    loader: lazyForPaint(() =>
        import(/* webpackChunkName: 'request-service-desk-cta' */ './hocs').then(({ default: footerCTA }) => footerCTA)
    ),
    LoadingSkeleton: () => <></>,
});
